<template>
  <div class="products-wrapper">
    <el-row :gutter="16">
      <el-col
          :xs="12" :sm="8" :md="6" :lg="6" :xl="4"
          v-for="(product, index) in products"
          :key="index"
          class="product-col"
      >
        <router-link :to="`/product/${product.slug}`" class="product-card-link">
          <div class="product-card">

            <!-- Image -->
            <div class="product-image-wrap">
              <img
                  v-if="product.thumbnail_image"
                  :src="productImage(product.thumbnail_image)"
                  :alt="product.name"
                  class="product-img"
              />
              <div v-else class="product-img-placeholder">
                <span>No Image</span>
              </div>

              <!-- Discount badge -->
              <span v-if="product.discount && product.discount !== 'null'" class="discount-badge">
                -{{ product.discount }}%
              </span>
            </div>

            <!-- Info -->
            <div class="product-info">
              <p class="product-name">{{ product.name }}</p>

              <div class="product-price">
                <template v-if="product.discount && product.discount !== 'null'">
                  <span class="price-current">৳ {{ getDiscountPrice(product.price, product.discount) }}</span>
                  <del class="price-original">৳ {{ product.price }}</del>
                </template>
                <span v-else class="price-current">৳ {{ product.price }}</span>
              </div>
            </div>

          </div>
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ProductsComponent',
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getDiscountPrice(price, discount) {
      if (discount && discount !== 'null') {
        const sum = (parseFloat(price) * parseFloat(discount)) / 100;
        return (parseFloat(price) - sum).toFixed(2);
      }
      return price;
    },
    addProductToCart(product) {
      this.$store.dispatch('shopingCart/addProductToCart', product);
    },
    productImage(img) {
      if (img) return `${process.env.VUE_APP_API_URL}${img}`;
    },
  },
};
</script>

<style scoped>
/* ── Grid wrapper ── */
.products-wrapper {
  width: 100%;
}

.product-col {
  margin-bottom: 16px;
}

/* ── Card link reset ── */
.product-card-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

/* ── Card ── */
.product-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.product-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  transform: translateY(-4px);
}

/* ── Image container — fixed aspect ratio ── */
.product-image-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  background: #f5f5f5;
  overflow: hidden;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  transition: transform 0.35s ease;
}

.product-card:hover .product-img {
  transform: scale(1.06);
}

.product-img-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbb;
  font-size: 13px;
  background: #f0f0f0;
}

/* ── Discount badge ── */
.discount-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #e53935;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 20px;
  letter-spacing: 0.3px;
}

/* ── Info section ── */
.product-info {
  padding: 12px 12px 14px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-name {
  font-size: 13px;
  font-weight: 600;
  color: #222;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-price {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: auto;
}

.price-current {
  font-size: 14px;
  font-weight: 700;
  color: #c0392b;
}

.price-original {
  font-size: 12px;
  color: #aaa;
  text-decoration: line-through;
}

/* ── Mobile adjustments ── */
@media (max-width: 576px) {
  .product-name {
    font-size: 12px;
  }
  .price-current {
    font-size: 13px;
  }
  .product-info {
    padding: 8px 8px 10px;
  }
}
</style>
